import React from 'react';
import { Button } from 'components/Button';
import { Modal } from 'components/Modal';

export const CostWarningModal = ({ costs = [], clickedOk, clickedClose }) => {
    const message = `Náklady nejsou konzistentní vůči daňovým sazbám.`;
    const buttonText = 'Odeslat';

    const formatCurrency = (value) => {
        const num = parseFloat(value);
        return !isNaN(num) && isFinite(num)
            ? num.toFixed(2).replace('.', ',')
            : '0,00';
    };

    
    const tableStyle = {
        width: '100%',
        marginTop: '1rem',
        borderCollapse: 'collapse',
    };

    const cellStyle = {
        padding: '0.25rem 0.5rem',
        borderBottom: '1px solid #eee',
        fontSize: '0.85rem',
        textAlign: 'right',
        width: '25%',
        display: 'inline-block',
        verticalAlign: 'top',
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    };

    const headerStyle = {
        ...cellStyle,
        backgroundColor:'var(--semilight)',
        color: '#333',
        fontWeight: 'bold',
    };

    const costRowStyle = {
        backgroundColor: 'var(--light)', 
        fontWeight: 'bold',
        display: 'block',
    };

    const itemRowStyle = {
        display: 'block',
    };

    const docTitleStyle = {
        marginTop: '1rem',
        fontWeight: 'bold',
        fontSize: '1rem',
    };

    return (
        <div style={{ position: 'relative', zIndex: 9999 }}>
            <Modal name={message} close={clickedClose}>
                <main
                    style={{
                        padding: '0rem 1rem',
                        minWidth: '30rem',
                        maxHeight: '60vh',
                        overflowY: 'auto',
                    }}
                >
                    {costs.map((docData, docIndex) => {
                        const { document, document_identifier, costs: docCosts, items } = docData;

                        return (
                            <div key={docIndex}>
                                <p style={docTitleStyle}>
                                    Dokument: {document_identifier || document}
                                </p>
                                <table style={tableStyle}>
                                    <thead>
                                        <tr style={{ display: 'block' }}>
                                            <th style={headerStyle}>Daňová sazba</th>
                                            <th style={headerStyle}>Základ bez DPH</th>
                                            <th style={headerStyle}>Daň</th>
                                            <th style={headerStyle}>Celkem s DPH</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {docCosts.map((cost, costIndex) => {
                                            const relatedItems = items.filter(item => item.tax_rate === cost.tax_rate);
                                            const showDetails = relatedItems.length <= 5;

                                            return (
                                            <React.Fragment key={costIndex}>
                                                <tr style={costRowStyle}>
                                                <td style={cellStyle}>{cost.tax_rate} %</td>
                                                <td style={cellStyle}>{formatCurrency(cost.value_original)}</td>
                                                <td style={cellStyle}>{formatCurrency(cost.tax)}</td>
                                                <td style={cellStyle}>{formatCurrency(cost.value_final)}</td>
                                                </tr>
                                                {showDetails ? (
                                                relatedItems.map((item, itemIndex) => (
                                                    <React.Fragment key={`${costIndex}-${itemIndex}`}>
                                                    <tr style={itemRowStyle}>
                                                        <td style={{ ...cellStyle, width: '100%', textAlign: 'left' }} colSpan={4}>
                                                        ({item.number}) {item.name}
                                                        </td>
                                                    </tr>
                                                    <tr style={itemRowStyle}>
                                                        <td style={cellStyle}>&nbsp;</td>
                                                        <td style={cellStyle}>{formatCurrency(item.value_original)}</td>
                                                        <td style={cellStyle}>{formatCurrency(item.tax)}</td>
                                                        <td style={cellStyle}>{formatCurrency(item.value_final)}</td>
                                                    </tr>
                                                    </React.Fragment>
                                                ))
                                                ) : (
                                                <tr style={itemRowStyle}>
                                                    <td style={{ ...cellStyle, width: '100%', textAlign: 'left' }} colSpan={4}>
                                                    {relatedItems.length} nekonzistentních položek
                                                    </td>
                                                </tr>
                                                )}
                                            </React.Fragment>
                                            );
                                        })}
                                        </tbody>

                                </table>
                            </div>
                        );
                    })}

                   
                </main>
                <p style={{ marginTop: '1rem', marginLeft: '1rem'  }}>Chcete přesto pokračovat?</p>
                <footer style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', padding: '1rem' }}>
                    <Button onClick={clickedClose}>Zrušit</Button>
                    <Button primary onClick={clickedOk}>{buttonText}</Button>
                </footer>
            </Modal>
        </div>
    );
};
